export const REACT_PAGE_VERSION = 1;
